import log from 'salvo-lite/log'

class HoverZoom {
    constructor (theme, elem) {
        log.debug('HoverZoom', 'Constructing', this)
        this._elem = elem
        this._options = Object.assign({
            zoomFactor: 2.5
        }, JSON.parse(this._elem.dataset.hoverZoom ? this._elem.dataset.hoverZoom : '{}'))
        this._transformElem = this._elem.querySelector('.data-hover-zoom-image')
        this._theme = theme
    }

    onInit () {
        log.debug('HoverZoom', 'Initiating')

        this._elem.addEventListener('mousemove', e => {
            let bounds = this._elem.getBoundingClientRect()
            let x = e.clientX - bounds.left
            let y = e.clientY - bounds.top
            let zoomX = -Math.round((x / bounds.width - 0.5) * bounds.width * (this._options.zoomFactor - 1) / this._options.zoomFactor)
            let zoomY = -Math.round((y / bounds.height - 0.5) * bounds.height * (this._options.zoomFactor - 1) / this._options.zoomFactor)

            let transform = `scale(${this._options.zoomFactor}) translate(${zoomX}px, ${zoomY}px)`
            this._transformElem.style.webkitTransform = transform
            this._transformElem.style.MozTransform = transform
            this._transformElem.style.msTransform = transform
            this._transformElem.style.OTransform = transform
            this._transformElem.style.transform = transform
        })

        this._elem.addEventListener('mouseout', e => {
            let transform = `scale(1) translate(0px, 0px)`
            this._transformElem.style.webkitTransform = transform
            this._transformElem.style.MozTransform = transform
            this._transformElem.style.msTransform = transform
            this._transformElem.style.OTransform = transform
            this._transformElem.style.transform = transform
        })

        log.debug('HoverZoom', 'Initiated')
    }
}

export default HoverZoom



// WEBPACK FOOTER //
// ./src/resources/scripts/components/HoverZoom.js